/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { PreferredSupplierPageComponent } from "@src/app/modules/supply/preferred-supplier-page/preferred-supplier-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const PreferredSupplierPageNavRoute = new NavRoute('suppliers/preferred', ()=>PreferredSupplierPageComponent, 'favorite').setViews(() => [{
        id: 'allSuppliers',
        name: 'All Agency Suppliers',
        helpText: 'All suppliers for the OMC - Agency suppliers with a transaction and any OMC specific suppliers that have been created',
        filterFields: {
            name: null
        },
    }]);
